<template>
    <div class="animated fadeIn">
        <component-new-header
            title="Items"
            @search-query="(val) => (filter = val)"
            :isLoading="isloader"
            @reload-data="refreshAllDataItem"
            :hasCreate="false"
        />
        <b-row>
            <b-col>
                <b-card style="min-height: 450px">
                    <b-row>
                        <b-col md="2" class="my-1">
                            <b-form-group label-cols-sm="3" class="mb-0">
                                <b-form-select
                                    :options="pageOptions"
                                    id="pagination"
                                    v-model="perPage"
                                />
                            </b-form-group>
                        </b-col>

                        <b-col
                            md="3"
                            class="my-1"
                            v-if="
                                $userRole === 'Partner' &&
                                segmentType === 'MARKET'
                            "
                        >
                            <b-form-group class="mb-0">
                                <eb-select
                                    type="select"
                                    :selected="selectedMarketId"
                                    :options="marketList"
                                    label="text"
                                    :id="'selectMarket'"
                                    placeholder="Select Market"
                                    @input="onChangeMarket"
                                ></eb-select>
                            </b-form-group>
                        </b-col>

                        <b-col
                            md="3"
                            class="my-1"
                            v-if="$userRole === 'Partner'"
                        >
                            <b-form-group class="mb-0">
                                <eb-select
                                    type="select"
                                    :selected="selectedMarketCategoryId"
                                    :options="marketCategory"
                                    label="text"
                                    :id="'selectcategory'"
                                    placeholder="Select Category"
                                    @input="onChangeCategory"
                                ></eb-select>
                            </b-form-group>
                        </b-col>

                        <b-col md="3" class="my-1">
                            <b-form-group class="mb-0">
                                <eb-select
                                    type="select"
                                    :selected="selectedCatalogId"
                                    v-model="selectedCatalogId"
                                    :options="catalogList"
                                    label="text"
                                    :id="'selectCatalog'"
                                    placeholder="Select Product Catalog"
                                    @input="catalogNameChange"
                                ></eb-select>
                            </b-form-group>
                        </b-col>

                        <b-col
                            md="3"
                            class="my-1"
                            v-if="
                                selectedCatalogId.value.length &&
                                userPermission.hasOwnProperty('CREATE_ITEM')
                            "
                        >
                            <router-link
                                :to="`item/create/${selectedCatalogId.value}`"
                            >
                                <button
                                    class="mr-1 btn btn-primary"
                                    variant="facebook"
                                    id="createItem"
                                >
                                    <i class="fa fa-plus"></i>
                                    <span class="ml-1"><b>Create</b></span>
                                </button>
                            </router-link>
                            <router-link
                                :to="`item/bulk/create/${selectedCatalogId.value}`"
                            >
                                <button
                                    v-if="this.$userRole === 'Partner'"
                                    class="mr-1 btn btn-primary"
                                    variant="facebook"
                                    id="createItem"
                                >
                                    <i class="fas fa-mail-bulk"></i>
                                    <span class="ml-1"><b>Bulk Create</b></span>
                                </button>
                            </router-link>
                        </b-col>
                    </b-row>
                    <b-table
                        id="table-transition-example"
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive="sm"
                        :items="itemTableData"
                        :fields="itemTableField"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        v-if="selectedCatalogId.value.length && !loading"
                        class="mt-2"
                        thead-class="header"
                        primary-key="_id"
                        show-empty
                        :tbody-transition-props="transProps"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(action)" slot-scope="data">
                            <b-button
                                v-if="
                                    userPermission.hasOwnProperty('VIEW_ITEM')
                                "
                                size="sm"
                                class="mr-2"
                                variant="primary"
                                @click="navigateToView(data, 'ViewItem')"
                                id="viewItem"
                            >
                                <i class="fa fa-eye"></i>
                            </b-button>
                            <b-button
                                v-if="
                                    userPermission.hasOwnProperty('UPDATE_ITEM')
                                "
                                size="sm"
                                class="mr-2"
                                style="background: #fe7b08; border: #fe7b08"
                                variant="primary"
                                @click="navigateToView(data, 'EditItem')"
                                id="editItem"
                            >
                                <i class="fa fa-pencil edit"></i>
                            </b-button>
                            <b-button
                                v-if="
                                    userPermission.hasOwnProperty('DELETE_ITEM')
                                "
                                size="sm"
                                class="mr-2"
                                id="deleteItem"
                                variant="danger"
                                @click="deleteItem(data)"
                            >
                                <i class="fa fa-trash bin"></i>
                            </b-button>
                            <b-button
                                v-if="userRole === 'Tenant'"
                                size="sm"
                                id="copyItem"
                                class="mr-2"
                                variant="primary"
                                @click="navigateToView(data, 'CopyItem')"
                            >
                                <i class="fa fa-copy"></i> Copy Item
                            </b-button>
                            <b-button
                                v-if="!data.item.isOffline"
                                size="sm"
                                id="viewWeb"
                                class="mr-2"
                                variant="primary"
                                @click="viewOnWeb(data.item._id)"
                            >
                                <i class="fa fa-podcast"></i> Live Product
                            </b-button>
                            <b-col md="auto">
                                <p
                                    class="m-0 p-0 mr-1 mt-2"
                                    style="font-size: 15px"
                                >
                                    {{
                                        data.item.isOffline
                                            ? "Offline"
                                            : "Online"
                                    }}
                                </p>
                                <c-switch
                                    @change="
                                        (e) =>
                                            offlineItem(data.item, data.index)
                                    "
                                    :value="data.item.isOffline"
                                    color="primary"
                                    class="mx-2 mt-2"
                                    variant="pill"
                                >
                                </c-switch>
                            </b-col>
                        </template>
                    </b-table>
                    <b-row
                        v-if="
                            selectedCatalogId.value.length &&
                            items.length > perPage &&
                            !loading
                        "
                    >
                        <b-col md="12">
                            <nav class="float-right">
                                <b-pagination
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                    v-model="currentPage"
                                    prev-text="Prev"
                                    next-text="Next"
                                    hide-goto-end-buttons
                                />
                            </nav>
                        </b-col>
                    </b-row>
                    <b-row v-if="loading">
                        <b-col md="6">
                            <atom-spinner
                                :animation-duration="1000"
                                :size="60"
                                color="#ff1d5e"
                                class="float-right my-4"
                            />
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import cTable from "../base/Table.vue";
import { mapState, mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentNewHeader from "@/components/componentNewHeader";
import { tenantWebsites } from "@/shared/tenantWebsites.config";
import { Switch as cSwitch } from "@/components/Switch";
export default {
    name: "ViewItem",
    components: {
        cTable,
        AtomSpinner,
        ebSelect,
        loader,
        ComponentNewHeader,
        cSwitch,
        tenantWebsites,
    },
    data: () => {
        return {
            mymodalclass: ["mymodalclass"],
            transProps: {
                name: "flip-list",
            },
            showDismissibleAlert: false,
            loading: false,
            isloader: false,
            items: [],
            provider: "",
            fields: [],
            filter: "",
            caption: "Table",
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            tableData: [],
            valuesMap: {},
            isAddresscapture: false,
            itemObj: {},
            perPage: 5,
            pageOptions: [5, 10, 15, 20, 25, 30],
            currentPage: 1,
            dark: false,
            sortBy: "createdAt",
            sortDesc: true,
        };
    },
    methods: {
        navigateToView(data, routeName) {
            if (this.userRole === "Tenant") {
                this.$router.push({
                    name: `Partner${routeName}`,
                    params: {
                        id: this.partnerAllData._id,
                        itemId: data.item._id,
                    },
                });
            } else {
                this.$router.push({
                    name: routeName,
                    params: { id: data.item._id },
                });
            }
        },
        async offlineItem(item, index) {
            const payload = {
                data: {
                    isOffline: !item.isOffline,
                    itemIds: [item._id],
                },
            };
            const itemIndex = this.perPage * (this.currentPage - 1) + index;
            const oldStatus = item.isOffline;
            this.$set(this.items, itemIndex, {
                ...item,
                isOffline: payload.data.isOffline,
            });

            try {
                await this.$store.dispatch("item/offlineItem", payload);
            } catch (err) {
                // if failed revert it
                this.$set(this.items, itemIndex, {
                    ...item,
                    isOffline: oldStatus,
                });
            }
            await this.refreshAllDataItem();
        },
        async viewOnWeb(productId) {
            const productURL = `${
                tenantWebsites[this.userTenantId].URL
            }/${productId}`;
            window.open(productURL, "_blank");
        },
        async onChangeMarket(data) {
            let searchString = `parent=${data.value}`;
            this.$store.dispatch("item/changeMarketId", data);
            try {
                await this.$store.dispatch(
                    "item/fetchCatalogList",
                    searchString,
                );
            } catch (error) {
                this.$toasted.error(error.message);
            }
        },
        async onChangeCategory(data) {
            let searchString = `parent=${data.value}`;
            this.$store.dispatch("item/changeMarketCategory", data);
            try {
                await this.$store.dispatch(
                    "item/fetchCatalogListByMarketCategory",
                    searchString,
                );
            } catch (error) {
                this.$toasted.error(error.message);
            }
        },
        async catalogNameChange(data) {
            this.$store.dispatch("item/changeCatelogId", data);
            if (data) {
                this.loading = true;
                const { VIEW_ALL_ITEMS } = this.permissions;
                let condition = {
                    provider: this.provider,
                    catalogId: data.value,
                };
                if (this.userRole === "Tenant") {
                    delete condition.provider;
                }
                await this.$store.dispatch(
                    "item/fetchItemsByCatalog",
                    condition,
                );
                let result = this.$store.getters["item/GetItemListByCatalog"];
                if (result.length > 0) {
                    this.items = result.map((e) => {
                        const { integer_attributes } = e;
                        const { string_attributes } = e;
                        if (integer_attributes) {
                            integer_attributes.filter((eb, idex) =>
                                eb.attribute_name === "Price"
                                    ? (e.Price = eb.attribute_value)
                                    : eb.attribute_name === "Stock"
                                      ? (e.stock = eb.attribute_value)
                                      : "",
                            );
                        }
                        if (string_attributes) {
                            string_attributes.filter((eb, idex) =>
                                eb.attribute_name === "Brand"
                                    ? (e.Brand = eb.attribute_value)
                                    : "",
                            );
                        }
                        return e;
                    });
                    this.setDefaultColumnsValue();

                    if (this.items.length === 0)
                        this.showDismissibleAlert = true;
                    else this.showDismissibleAlert = false;

                    this.fields = [];
                    this.fields.push(
                        {
                            key: "Name",
                            label: "Name",
                            sortable: true,
                        },
                        {
                            key: "Price",
                            label: "Price",
                        },
                        {
                            key: "Type",
                            label: "Type",
                        },
                        {
                            key: "productType",
                            label: "Product Type",
                        },

                        {
                            key: "Inventory",
                            label: "Inventory",
                        },
                        {
                            key: "IsSellable",
                            label: "Is Sellable",
                        },
                    );

                    result[0]["Brand"]
                        ? this.fields.push({
                              key: "Brand",
                              label: "Brand",
                          })
                        : null;

                    result.map((Obj) => {
                        Obj.Name = Obj.string_attributes[0].attribute_value;
                    });
                    for (let key in result[0]) {
                        if (
                            typeof result[0][key] !== "object" &&
                            this.fields.length < 6 &&
                            key != "string_attributes[0].attribute_value" &&
                            key != "_id" &&
                            key != "tenant" &&
                            key != "provider" &&
                            key != "catalogId" &&
                            key != "createdAt" &&
                            key != "isDeleted" &&
                            key != "updatedAt" &&
                            key != "Lat" &&
                            key != "Lng" &&
                            key != "Country" &&
                            key != "State" &&
                            key != "City" &&
                            key != "Area" &&
                            key != "productType" &&
                            key != "Type" &&
                            key != "Inventory" &&
                            key != "IsSellable" &&
                            key != "AvgRating" &&
                            key != "manufacturerId"
                        ) {
                            this.fields.push({
                                key: key,
                                label: key,
                            });
                        }
                    }
                    this.loading = false;
                    this.fields.push({
                        key: "action",
                        label: "Action",
                    });
                } else {
                    this.loading = false;
                    this.items = [];
                }
            } else {
                this.items = [];
                this.loading = false;
            }
            this.$store.dispatch("item/storeItemTableData", {
                items: this.items,
                fields: this.fields,
            });
        },

        setDefaultColumnsValue() {
            this.items.map((obj) => {
                if (!obj["Type"]) {
                    obj["Type"] = "PRODUCT";
                }
                if (!obj["productType"]) {
                    obj["productType"] = "NORMAL";
                }
                if (!["TRUE", "FALSE"].includes(obj["IsSellable"])) {
                    obj["IsSellable"] = "TRUE";
                }

                if (!obj["Inventory"]) {
                    obj["Inventory"] = "FALSE";
                } else {
                    obj["Inventory"] === "1"
                        ? (obj["Inventory"] = "TRUE")
                        : (obj["Inventory"] = "FALSE");
                }
            });
        },

        async deleteItem(rowdata) {
            await this.$store.dispatch("item/fetchItemById", rowdata.item._id);
            let data = this.$store.getters["item/GetCurrentItemObject"];
            let result = data.response[0];
            this.itemObj = result;
            let keys = Object.keys(result);
            let typeSet = new Set(["String", "Number", "Object", "Array"]);
            let attributesMap = new Map([
                ["String", []],
                ["Number", []],
                ["Object", []],
                ["Array", []],
            ]);
            let valuesMap = result;
            result.attributeItems.forEach((item) => {
                if (item) {
                    if (item.attributeName === "Address") {
                        this.isAddresscapture = true;
                    }
                    let type = item.attributeValueType,
                        name = item.attributeName;
                    // check key value is allowed type
                    if (typeSet.has(type)) {
                        let attObj = {
                            ...item,
                            type,
                            name,
                        };
                        attributesMap.set(
                            type,
                            attributesMap.get(type).concat([attObj]),
                        );
                        if (type == "Array") {
                            if (attObj.UIConcern === "Select") {
                                let options = new Map(
                                    attObj.attributeItems.map((a) => [
                                        a._id,
                                        {
                                            label: a.attributeName,
                                            value: a._id,
                                        },
                                    ]),
                                );
                                valuesMap[name] = valuesMap[name].map((o) =>
                                    options.get(o),
                                );
                            }
                            if (attObj.UIConcern === "Object") {
                                valuesMap[name] = valuesMap[name];
                            }
                            if (attObj.UIConcern === "Checkbox") {
                                valuesMap[name] = valuesMap[name];
                            }
                        }
                        if (["Number", "String"].includes(type)) {
                            const addresses = {
                                Number: "integer_attributes",
                                String: "string_attributes",
                            };
                            const attributes = result[addresses[type]];
                            const valueItem = attributes.find(
                                (pair) => pair.attribute_name == name,
                            );
                            if (valueItem) {
                                valuesMap[name] = valueItem.attribute_value;
                            }
                        }
                    }
                }
            });
            this.attributesMap = attributesMap;
            this.valuesMap = valuesMap;

            let payload = {
                ...this.valuesMap,
                images: {
                    icon: "",
                    smallImage: "",
                    bigImage: "",
                },
            };
            // Casting select fields
            Object.keys(this.valuesMap).forEach((key) => {
                let tempItem = this.valuesMap[key];
                if (
                    Array.isArray(tempItem) &&
                    tempItem.length > 0 &&
                    tempItem[0] &&
                    tempItem[0].value
                ) {
                    payload[key] = tempItem.map((v) => v.value);
                }
            });

            payload.string_attributes[0].attribute_value = payload.Name;
            payload.catalogId = this.itemObj.catalogId;
            delete payload.product_summary;
            delete payload.updatedAt;
            delete payload.createdAt;
            delete payload._id;
            delete payload.Title;
            delete payload.attributeItems;
            delete payload.string_attributes;
            delete payload.integer_attributes;
            delete payload.tags;
            payload.isDeleted = true;
            if (payload["Name"] === "") {
                payload["Name"] = this.itemObj.Name;
                payload["string_attributes[0].attribute_value"] =
                    payload["Name"];
            }

            payload.images.icon = this.itemObj.product_summary.images.icon;
            payload.images.smallImage =
                this.itemObj.product_summary.images.smallImage;
            payload.images.bigImage =
                this.itemObj.product_summary.images.bigImage;

            // check for address Object if exist //////
            if (this.isAddresscapture) {
                payload.City = this.itemObj.Address.City;
                payload.Country = this.itemObj.Address.Country;
                payload.State = this.itemObj.Address.State;
                payload.Lat = this.itemObj.Address.Lat;
                payload.Lng = this.itemObj.Address.Lng;
                payload.Address = {
                    Lng: payload.Lng,
                    Lat: payload.Lat,
                    City: payload.City,
                    State: payload.State,
                    Country: payload.Country,
                    Address: this.itemObj.Address.Address,
                };
                payload.Area = payload.Address.Address;
            }
            // dataObj for API
            let dataObj = { id: rowdata.item._id, object: payload };
            this.$swal({
                title: "Delete this Item?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("item/updateItemById", dataObj)
                        .then((result) => {
                            this.$toasted.success("Item Deleted");
                            let condition = {
                                provider: this.provider,
                                catalogId: this.selectedCatalogId.value,
                            };
                            this.refreshAllDataItem();
                            if (this.userRole === "Tenant") {
                                delete condition.provider;
                            }
                            this.$store.dispatch(
                                "item/fetchItemsByCatalog",
                                condition,
                            );
                            this.items = this.items.filter(
                                (obj) => obj._id !== rowdata.item._id,
                            );
                        })
                        .catch((err) => {
                            this.$toasted.error("Item not deleted");
                        });
                }
            });
        },

        async refreshAllDataItem() {
            this.isloader = true;
            try {
                this.provider = this.$store.getters["auth/getUserID"];
                if (this.userRole === "Tenant") {
                    await this.$store.dispatch("item/loadTenantCatelogTree");
                } else {
                    this.catalogNameChange(this.selectedCatalogId);
                }
            } catch (error) {
                this.$toasted.error(error.message);
            } finally {
                this.isloader = false;
            }
        },
    },
    mounted: async function () {
        if (this.partnerAllData == null && this.$route.params.id) {
            await this.$store.dispatch(
                "partner/fetchPartnerById",
                this.$route.params.id,
            );
        }
        this.isloader = true;
        try {
            this.provider = this.$store.getters["auth/getUserID"];
            if (this.userRole === "Tenant") {
                let tenCatelogTree =
                    this.$store.getters["catalog/GetTenantCatalogTree"].length;
                if (!tenCatelogTree.length) {
                    await this.$store.dispatch("item/loadTenantCatelogTree");
                }
            } else {
                if (!this.marketList.length) {
                    await this.$store.dispatch("item/loadPartnerMarketSegment");
                }
            }
        } catch (error) {
            this.$toasted.error(error.message);
        } finally {
            await this.refreshAllDataItem();
            this.isloader = false;
        }
    },
    computed: {
        ...mapState("auth", ["permissions"]),
        ...mapState({
            marketList: (state) => state.item.marketList,
            segmentType: (state) => state.item.segmentType,
            marketCategory: (state) => state.item.marketCategory,
            catalogList: (state) => state.item.catalogList,
            selectedMarketId: (state) => state.item.selectedMarketId,
            selectedMarketCategoryId: (state) =>
                state.item.selectedMarketCategoryId,
            selectedCatalogId: (state) => state.item.selectedCatalogId,
            itemTableField: (state) => state.item.itemTableField,
            itemTableData: (state) => state.item.itemTableData,
        }),
        ...mapGetters({
            partnerAllData: "partner/GetPartnerData",
        }),
        userRole() {
            if (this.$store.getters["auth/getUserRole"]) {
                return this.$store.getters["auth/getUserRole"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
            }
        },
        userTenantId() {
            if (this.userRole === "Tenant") {
                return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
            }
            return JSON.parse(sessionStorage.getItem("userLogin"))["tenant"];
        },
        totalRows() {
            return this.items.length;
        },
        userPermission() {
            return this.$store.getters["auth/getUserPermissions"];
        },
    },
};
</script>

<style scoped>
.mymodalclass > div {
    margin-top: 45px !important;
}
.text-center {
    text-align: center !important;
}
[data-font="20"] {
    font-size: 20px;
}
.edit {
    color: #ffffff !important;
}
.bin {
    color: white !important;
}
</style>
<style>
table.table-bordered > tbody > tr {
    /* text-transform: capitalize; */
    text-align: center;
}
table#table-transition-example .flip-list-move {
    transition: transform 1s;
}
</style>
